import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import SideMenu from '../component/sideMenu/sideMenu';
import './layout.css';
import OurHeader from '../component/header/header';
import ChatWidget from '../component/chatWidget/chatWidget';
import { Collapsed } from '../redux/actions/MenuAction';

const { Content, Header, Footer } = Layout;

const LayoutWithRoute = ({ children, marginLeft, marginRight, menu, Collapsed }) => {
  const isMenuOpenOnMobile = !menu;

  return (
    <Layout
      className="crm-main-layout"
      style={{
        minHeight: '100vh',
        flexDirection: 'row',
        marginLeft: marginLeft ? marginLeft : 0,
        marginRight: marginRight ? marginRight : 0,
        transition: 'margin 0.2s ease-in-out',
      }}
    >
      {/* Mobile Drawer Overlay Backdrop */}
      {isMenuOpenOnMobile && (
        <div
          className="mobile-sidebar-backdrop active"
          onClick={() => {
            Collapsed(true);
            localStorage.setItem('@MENU', 'true');
          }}
        />
      )}

      <SideMenu />
      <Layout className="crm-content-layout">
        <Header className="site-layout-background crm-header-container" style={{ padding: '0px' }}>
          <div className="crm-header-wrapper" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 0, width: '100%', marginBottom: 30, padding: '0px 0px' }}>
            <OurHeader />
            <ChatWidget />
          </div>
        </Header>
        <Content className="crm-app-content" style={{ margin: '20px 16px' }}>{children}</Content>

        <Footer className="crm-footer" style={{ textAlign: 'center' }}>
          DashBoard ©{new Date().getFullYear()} Created by SAAEI COMPANY
        </Footer>
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  menu: state.menu.menu,
  isRTL: state.lang.isRTL,
});

const mapDispatchToProps = {
  Collapsed,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithRoute);